<template>
  <div>
    <div class="field-card">
      <div class="align-map">
        <AreaSelector></AreaSelector>

        <b-row align-v="start" align-h="start">
          <template v-for="(station, idx) in station_list">
            <b-col
              sm="6"
              lg="6"
              :key="idx"
              class="calendar-layout"
              v-if="station.area.toLowerCase() == display_area.toLowerCase()"
            >
              <div class="calendar-card text-center">
                <div class="title" @click="update_selected(station.id)">
                  <div class="field-name">
                    {{ $t("field.location_" + station.id) }}
                  </div>
                  <br />
                  <div class="crop-name">
                    {{ $t("field.name_" + station.id) }}
                  </div>
                </div>

                <!-- <div class="calendar-block mr-2">
                                    <Calendar :title="$t('menu.flowering_date')" :type="'flowering'" :date="data[ station.id ].flowering_date"></Calendar>
                                </div>

                                <div class="calendar-block">
                                    <Calendar :title="$t('menu.blooming_date')" :type="'blooming'" :date="data[ station.id ].blooming_date"></Calendar>
                                </div> -->

                <div v-if="data[station.id]">
                  <StageProcgress :data="data[station.id]"></StageProcgress>
                </div>
              </div>
            </b-col>
          </template>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoadingInfo from "@/components/LoadingInfo";
// import Calendar from "./Calendar";
import StageProcgress from "./Stage_Procgress";
import AreaSelector from "./Area_Seletor";

export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  components: {
    LoadingInfo,
    // Calendar,
    StageProcgress,
    AreaSelector,
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      display_area: (state) => state.data.display_area,
      display_station: (state) => state.data.display_station,
      station_list: (state) => state.data.stations_info,
    }),
  },
  watch: {},
  methods: {
    go_detail() {
      let html = document.getElementById("section-field-detail");

      html.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    },

    update_selected(station_code) {
      this.go_detail();
      this.$store.commit("data/select_station", station_code);
    },
  },
};
</script>

<style lang="scss" scoped>
$flowering-color: #fe6357;
$blooming-color: #232175;

.align-map {
  width: 100%;
  padding: 0px 20px 0px 15px;
  margin-bottom: 15px;
  font-size: 1rem;
}

.field-card {
  margin: 0px 5px 10px 0px;
  // padding: 15px 20px 10px 20px;
  // border-radius: 6px;
  // border: 1px solid #52517d;
  // border: 1px solid #dcd9d9;

  @media screen and (max-width: 500px) {
    padding: 15px 10px 10px 10px;
  }

  .title {
    margin-top: 0px;
    margin-bottom: 5px;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }
  .sub-title {
    display: inline-block;
    padding: 3px 10px;
    color: #232175;
    background-color: rgba($flowering-color, 0.3);
    font-weight: bold;
    border-radius: 2px;
    margin-right: 10px;
  }
  .field-name {
    display: inline-block;
    color: $flowering-color;
  }
  .crop-name {
    display: inline-block;
    color: $blooming-color;
  }
  .fa-minus {
    margin: 0px 5px;
  }
}

.calendar-layout {
  min-width: 220px;
  margin-bottom: 10px;
}

.calendar-card {
  border: 1px solid rgba(gray, 0.1);
  padding: 13px 5px 5px 5px;
  border-radius: 5px;
  background: rgba(gray, 0.06);
}

.calendar-block {
  display: inline-block;
  width: 45%;
}
</style>
